;(function () {
  'use strict'

  angular
    .module('contrast.donut')
    .directive('csDonutTooltip', ['$compile', csDonutTooltip])

  function csDonutTooltip($compile) {
    return {
      restrict: 'A',
      scope: {
        template: '@',
        displayPosition: '@',
        displayClass: '@',
        csDonutTooltipDataIndex: '@',
        csDonutTooltipIndex: '@',
        data: '='
      },
      link: link
    }

    function link($scope, element) {
      if (!element.scope().tooltipLoaded) {
        $scope.tooltipLoaded = true
        element.attr('uib-tooltip-template', $scope.template)
        element.attr('tooltip-placement', $scope.displayPosition)
        element.attr('tooltip-append-to-body', true)
        element.attr(
          'tooltip-class',
          'no-pointer-events ' + $scope.displayClass
        )
        $compile(element)($scope)
      }
    }
  }
})()
